<template>
  <svg class="svg" :class="[color, hover]" width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2495 3.52594C12.2477 3.52594 13.8726 5.15072 13.8726 7.14866C13.8726 9.14631 12.2476 10.7714 10.2495 10.7714C8.25217 10.7714 6.62726 9.14617 6.62726 7.14866C6.62726 5.15086 8.25202 3.52594 10.2495 3.52594ZM10.2495 9.59738C11.5996 9.59738 12.6986 8.49843 12.6986 7.14866C12.6986 5.79861 11.5998 4.69995 10.2495 4.69995C8.89949 4.69995 7.80126 5.79844 7.80126 7.14866C7.80126 8.49861 8.89965 9.59738 10.2495 9.59738ZM20.3843 6.86906C20.5466 7.0886 20.5376 7.39083 20.3612 7.5978L20.1506 7.84658C19.3005 8.85205 18.8748 9.34109 18.3076 9.94312C15.6578 12.7553 13.133 14.2969 10.2482 14.2969C7.01785 14.2969 4.77118 12.8724 1.88045 9.57858C1.47922 9.1214 1.16031 8.74482 0.428903 7.87114L0.138596 7.52394C-0.0454852 7.30617 -0.046182 6.98892 0.136422 6.77041C4.12322 1.97727 6.85808 0 10.2482 0C14.0373 0 17.0588 2.38147 20.3843 6.86906ZM10.2482 1.17401C7.34215 1.17401 4.97304 2.85276 1.35255 7.14557C5.20912 11.7499 6.98213 13.1229 10.2482 13.1229C13.4019 13.1229 15.5845 11.4137 19.163 7.19603C16.1819 3.25976 13.4692 1.17401 10.2482 1.17401Z" fill="#7B8084"/>
  </svg>
</template>

<script>
export default {
  name: 'eye_on',
  props: {
    color: { // класс цвета который красит картинку
      type: String,
      default: ''
    },
    hover: { // класс цвета который красит картинку при :hover
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.svg.grey path {
  fill: #7B8084
}
.svg.black:hover path {
  fill: #000;
}
</style>
